import { isJest } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { ncWalletApi } from '../data-access/api';

type UseMigrationCounterMutationProps = { hashes: Array<string> };

export const useMigrationCounterMutation = () => {
	const isTestEnv = isJest();

	return useMutation({
		mutationFn: async ({ hashes }: UseMigrationCounterMutationProps) =>
			(await ncWalletApi).putNon_custodial_provider_managementPutMigrationsHashes(
				{ hashes },
				{ customErrorInterceptor: () => true }
			),
		retry: isTestEnv ? 0 : 3
	});
};
